import { compose } from 'redux';
import { withProps, setDisplayName } from 'recompose';

import { initialRate } from 'sharedParts/config/blockConfig/questionScale';

import RatingFormField from '../../rating/RatingFormField';
import withScaleRatingIcons from '../withScaleRatingIcons';
import styles from './ScaleQuestionFormField.scss';

export default compose(
  setDisplayName('ScaleQuestionFormField'),
  withScaleRatingIcons,
  withProps(({ ratingItemClassName, block, block: { segment } }) => ({
    initialRate,
    ratingItemClassName,
    segmentLabelList: block[segment],
    className: styles.container,
  })),
)(RatingFormField);
